import React, { Component } from 'react';

class Paragraphs extends Component {
    render() {
        const parts = this.props.text.split("\n\n");
        return (
            <div>
                {parts.map((part) => (
                    <p>{part}</p>
                ))}
            </div>
        );
    }
}

export default Paragraphs;



// WEBPACK FOOTER //
// ./src/reference/ui/Paragraphs.js